import { createSlice } from '@reduxjs/toolkit';

import { fetchTitleGenerationConfig, generateAItitle } from './actions';
import type { AIState } from './type';

export const DEFAULT_DEBOUNCE_TIME = 10 * 1000;

const initialState: AIState = {
  isGeneratingTitle: false,
  title: undefined,
  config: {
    enable_AI_title_generation: true,
    debounce_ms_AI_title_generation: DEFAULT_DEBOUNCE_TIME,
  },
  isFetchingConfig: false,
};

const aiSlice = createSlice({
  name: 'ai',
  initialState,
  reducers: {
    resetAITitleState(state) {
      state.title = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      // title generate
      .addCase(generateAItitle.pending, (state) => {
        state.isGeneratingTitle = true;
      })
      .addCase(generateAItitle.fulfilled, (state, action) => {
        state.title = action.payload;
        state.isGeneratingTitle = false;
      })
      .addCase(generateAItitle.rejected, (state, _action) => {
        state.isGeneratingTitle = false;
      })
      // fetch config
      .addCase(fetchTitleGenerationConfig.pending, (state) => {
        state.isFetchingConfig = true;
      })
      .addCase(fetchTitleGenerationConfig.fulfilled, (state, action) => {
        state.isFetchingConfig = false;
        state.config = action.payload;
      })
      .addCase(fetchTitleGenerationConfig.rejected, (state) => {
        state.isFetchingConfig = false;
      });
  },
});

export const { resetAITitleState } = aiSlice.actions;
export const aiReducer = aiSlice.reducer;
